const bundlesRootEl = document.getElementById('bundleProductApp');
const tesbrosBundleModal= {
    data() {
        return {

        }
    },
    inject: ['isMounted','showModal','modalHeader','modalBody'],
    emits: ['close'],
    methods: {
        closeModal() {
            this.$emit('close');
        }
    },
    template: `
<teleport to="#bundleAppModal" v-if="isMounted"><transition name="modal">
    <div class="modal-mask" v-if="showModal">
      <div class="modal-wrapper" @click="closeModal()">
        <div class="modal-container" @click.stop="">
          <div class="modal-header" v-html="modalHeader"></div>
          <div class="modal-body content" v-html="modalBody"></div>
          <div class="modal-footer">
            <div class="popup-actions"><button type="button" class="button" @click="closeModal()">Close</button></div>
          </div>
          <button class="modal-close button button--close" @click="closeModal()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>
  </transition></teleport>`,
}
const tesbrosBundleTier = {
    data() {
        return {

        }
    },
    props: {
        tier: Object
    },
    inject: ['products','tiers','freeItem','checkoutLoading'],
    mounted () {},
    computed: {
        variants() {
            return this.$store.getters['bundles/items'];
        },
        inCart() {
            return this.variants.filter(variant => variant.in_cart === true && variant.id !== this.freeItem.variants[0].id);
        },
        freeItemInCart() {
            return this.variants.find(variant => variant.in_cart === true && variant.id === this.freeItem.variants[0].id);
        },
        isActive() {
            let itemsInCart = this.inCart.length;
            if(itemsInCart === 1 && this.freeItemInCart) {
                itemsInCart = 2;
            }
            return (this.tier && itemsInCart >= this.tier.min);
        }
    },
    methods: {},
    template: `<div class="bundle-products__tier" :class="{'active': isActive}">
      <div class="bundle-products__tier-icon"></div>
      <div class="bundle-products__tier-title">{{tier.title}}</div>
      <div class="bundle-products__tier-subtitle">{{tier.subtitle}}</div>
    </div>`
}
const tesbrosMainBundleItem = {
    data() {
        return {
            selected: [],
            error: false
        }
    },
    props: {
        item: Object
    },
    inject: ['products','tiers','freeItem','checkoutLoading','mainOptions'],
    emits: ['select','add'],
    mounted () {
        this.selectedVariant.options.forEach(o => this.selected.push(o))
    },
    computed: {
        title() {
            return this.discountPercent > 0 ? `Buy the ${this.item.title} &amp; <span>save ${this.discountPercent}%</span>` : this.item.title;
        },
        selectedVariant() {
            return this.item.variants.find(v => v.id === this.item.selected_variant_id)
        },
        price() {
            return (this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > this.selectedVariant.price) ? this.selectedVariant.compare_at_price : this.selectedVariant.price;
        },
        specialPrice() {
            return this.selectedVariant.price;
        },
        discountPercent() {
            return this.price > this.specialPrice ? Math.round((this.price - this.specialPrice)/this.price*100) : 0;
        }
    },
    methods: {
        onChange() {
            this.error = false;
            this.$emit('select', this.selected);
        },
        onAdd() {
            if(this.selected.length < this.item.options.length) {
                this.error = true;
                return false;
            }
            this.$emit('add', this.selected);
        },
        notAvailable(index, option) {
            if(this.selected.length === 0) {
                return true;
            }
            let found = [];
            if(index === 0) {
                found = this.item.variants.filter(v => v.options[index] === option)
            } else if(index === 1) {
                if(this.selected[0]) {
                    found = this.item.variants.filter(v => v.options[0] === this.selected[0] && v.options[index] === option)
                } else {
                    found = this.item.variants.filter(v => v.options[index] === option)
                }
            } else if(index === 2) {
                if(this.selected[0] && this.selected[1]) {
                    found = this.item.variants.filter(v => v.options[0] === this.selected[0] && v.options[1] === this.selected[1] && v.options[index] === option)
                } else if(this.selected[0]) {
                    found = this.item.variants.filter(v => v.options[0] === this.selected[0] && v.options[index] === option)
                } else {
                    found = this.item.variants.filter(v => v.options[index] === option)
                }
            }
            if(found.length === 0 && this.selected[index] === option) {
                this.selected.splice(index,1);
            }
            return found.length === 0;
        }
    },
    template: `<div class="bundle-product__main" :class="{'loading': checkoutLoading}">
        <div class="legend" v-html="title"></div>
        <p>{{item.very_short_desc ? item.very_short_desc : item.short_description}}</p>
        <div class="bundle-product__main-wrapper">
            <div class="bundle-product__main-image"><img :src="item.img_url" alt=""></div>
            <div class="bundle-product__main-info">
               <ul>
                    <li v-for="(mainOption, index) in mainOptions" :key="index">
                        <strong>{{item.options[index]}}</strong>
                        <ul>
                            <li v-for="(option, jindex) in mainOption" :key="jindex">
                                <input type="radio" class="sr-only" :value="option" v-model="selected[index]" :id="'main-bundle-option-'+index+'-'+jindex" @change="onChange()" :disabled="notAvailable(index,option)">
                                <label :for="'main-bundle-option-'+index+'-'+jindex">{{option}}</label>
                            </li>
                        </ul>
                    </li>
                </ul>
                <p class="error" v-if="error">Please select options</p>
                <div class="prices"><span>{{formatCurrency(specialPrice)}}</span><span class="old-price" v-if="price > specialPrice">{{formatCurrency(price)}}</span></div>
                <button type="button" class="button" @click="onAdd()">Add To Cart</button>
                <p><a href="#">Learn More</a></p>
            </div>
        </div>
    </div>`
}
const tesbrosBundleProduct = {
    data() {
        return {
            selected: [],
            error: false
        }
    },
    props: {
        product: Object
    },
    inject: ['products','tiers','freeItem','checkoutLoading'],
    emits: ['toggle','modal'],
    mounted () {
        this.product.variants.find(v => v.id = this.product.default_variant_id).options.forEach(o => this.selected.push(o))
    },
    computed: {
        variants() {
            return this.$store.getters['bundles/items'];
        },
        item() {
            let found = null;
            if(this.product.has_only_default_variant === false && this.selected.length === this.product.options.length) {
                found = this.product.variants.find(v => v.options.length === this.selected.length && v.options.every((value,index) => value === this.selected[index]));
            }
            if(!found) {
                found = this.product.variants.find(v => v.id = this.product.default_variant_id);
            }
            return found;
        },
        inCart() {
            return this.variants.filter(variant => variant.in_cart === true && variant.id !== this.freeItem.variants[0].id);
        },
        freeItemInCart() {
            return this.variants.find(variant => variant.in_cart === true && variant.id === this.freeItem.variants[0].id);
        },
        tier() {
            let tier = {
                'percent': 0
            };
            if(this.inCart && this.inCart.length > 0) {
                let itemsInCart = this.inCart.length;
                if(itemsInCart === 1 && this.freeItemInCart) {
                    itemsInCart = 2;
                }
                const tiers = this.tiers.filter(t => itemsInCart >= t.min);
                tier = tiers.length > 0 ? tiers.reduce((prev, current) => (prev.min > current.min) ? prev : current) : tier;
            }
            return tier;
        },
        special() {
            if(this.item.id === this.freeItem.variants[0].id && this.inCart.length >= this.tier.min) {
                return 0
            } else {
                return this.tier.percent > 0 ? (this.item.price - (this.item.price * this.tier.percent / 100)) : -1;
            }
        },
        options() {
            let op = [];
            this.product.options.forEach((option, index) => {
                op.push([...new Set(this.product.variants.map(variant => variant.options[index]))]);
            });
            return op;
        }
    },
    methods: {
        openModal(url) {
            this.$emit('modal', url);
        },
        onChange() {
            this.error = false;
            //this.$emit('select', this.selected);
        },
        onClick() {
            this.$emit('toggle', this.item);
        },
        openGallery() {
            const product = this.products.find(p => p.id === this.product.id);
            const items = [];
            product.media.forEach(media => {
                if(media.media_type === 'image') {
                    items.push({
                        src:  media.src
                    })
                }
            })
            if(items.length > 0) {
                $.fancybox.open(items);
            }
        }
    },
    template: `<div class="bundle-products__item" :class="{'active': item.in_cart}">
        <div class="item-image">
            <a v-if="product.img_url" :href="product.img_url" @click.prevent="openGallery()">
               <img :src="product.img_url" alt="">
            </a>
        </div>
        <div class="item-details">
            <strong>{{product.title}}</strong>
            <p>{{product.very_short_desc ? product.very_short_desc : product.short_description}}</p>            
            <ul v-if="!product.has_only_default_variant">
                <li v-for="(mainOption, index) in product.options" :key="index">
                    <strong>{{mainOption}}</strong>
                    <select v-model="selected[index]" :id="'main-bundle-option-'+index" @change="onChange()">
                        <option :value="option" v-for="(option, jindex) in options[index]" :key="jindex">{{option}}</option>
                    </select>
                    <p v-if="product && product.hasOwnProperty('options_links') && product.options_links && product.options_links.hasOwnProperty(mainOption)"><a :href="'/pages/'+product.options_links[mainOption]" @click.prevent="openModal('/pages/'+product.options_links[mainOption])">What's the difference?</a></p>   
                </li>
            </ul>
        </div>
        <div class="item-actions">
            <button type="button" class="button" @click="onClick()">
                <span class="checkmark" v-if="item.in_cart"></span>
                {{item.in_cart ? 'Added' : 'Add'}}
            </button>        
            <strong :class="{'old-price': special >= 0}">{{formatCurrency(item.price)}}</strong>
            <span v-if="special >= 0">{{formatCurrency(special)}}</span>
        </div>
    </div>`
}
const tesbrosBundleItem = {
    data() {
        return {

        }
    },
    props: {
        item: Object
    },
    inject: ['products','tiers','freeItem','checkoutLoading'],
    emits: ['toggle'],
    mounted () {},
    computed: {
        variants() {
            return this.$store.getters['bundles/items'];
        },
        inCart() {
            return this.variants.filter(variant => variant.in_cart === true && variant.id !== this.freeItem.variants[0].id);
        },
        freeItemInCart() {
            return this.variants.find(variant => variant.in_cart === true && variant.id === this.freeItem.variants[0].id);
        },
        tier() {
            let tier = {
                'percent': 0
            };
            if(this.inCart && this.inCart.length > 0) {
                let itemsInCart = this.inCart.length;
                if(itemsInCart === 1 && this.freeItemInCart) {
                    itemsInCart = 2;
                }
                const tiers = this.tiers.filter(t => itemsInCart >= t.min);
                tier = tiers.length > 0 ? tiers.reduce((prev, current) => (prev.min > current.min) ? prev : current) : tier;
            }
            return tier;
        },
        special() {
            if(this.item.id === this.freeItem.variants[0].id && this.inCart.length === this.tier.min) {
                return 0
            } else {
                return this.tier.percent > 0 ? (this.item.price - (this.item.price * this.tier.percent / 100)) : -1;
            }
        },
    },
    methods: {
        onClick() {
            this.$emit('toggle', this.item);
        },
        openGallery() {
            const product = this.products.find(p => p.id === this.item.product_id);
            const items = [];
            product.media.forEach(media => {
                if(media.media_type === 'image') {
                    items.push({
                        src:  media.src
                    })
                }
            })
            if(items.length > 0) {
                $.fancybox.open(items);
            }
        }
    },
    template: `<div class="bundle-products__item" :class="{'active': item.in_cart}">
        <div class="item-image">
            <a :href="item.image" @click.prevent="openGallery()">
               <img v-if="item.image" :src="item.image" alt="">
            </a>
        </div>
        <div class="item-details">
            <strong>{{item.title}}</strong>
            <p>{{item.short_description}}</p>            
        </div>
        <div class="item-actions">
            <button type="button" class="button" @click="onClick()">
                <span class="checkmark" v-if="item.in_cart"></span>
                {{item.in_cart ? 'Added' : 'Add'}}
            </button>        
            <strong :class="{'old-price': special >= 0}">{{formatCurrency(item.price)}}</strong>
            <span v-if="special >= 0">{{formatCurrency(special)}}</span>
        </div>
    </div>`
}
const tesbrosBundleKits = {
    data() {
        return {
            selected: null,
            selectedOptions: [],
            selectedExtras: {},
            error: false
        }
    },
    props: {
        product: Object,
        items: Array
    },
    inject: ['step','from','flkty','totalImages','mainImage','products','checkoutLoading'],
    emits: ['update','add','select','modal'],
    watch: {
        selected(newSelected, oldSelected) {
            if(newSelected && newSelected.hasOwnProperty('id')) {
                this.selectedOptions = [];
                this.selected.variants.find(v => v.id = this.selected.default_variant_id).options.forEach(o => this.selectedOptions.push(o));
            } else {
                this.selectedOptions = [];
                this.resetImages(true);
            }
        }
    },
    mounted () {},
    computed: {
        mainOptions() {
            let o = [];
            if(this.selected && this.selected.hasOwnProperty('options') && this.selected.options && this.selected.options.length > 0) {
                this.selected.options.forEach((option, index) => {
                    o.push([...new Set(this.selected.variants.map(variant => variant.options[index]))]);
                });
            }
            return o;
        },
        selectedVariant() {
            return this.selected && this.selected.hasOwnProperty('id') && this.selectedOptions.length > 0 ?
                this.selected.variants.find(v => v.options.length === this.selectedOptions.length && v.options.every((value,index) => value === this.selectedOptions[index])) :
                this.selected.variants.find(v => v.id = this.selected.default_variant_id);
        },
        price() {
            if(this.selectedVariant) {
                return (this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > this.selectedVariant.price) ? this.selectedVariant.compare_at_price : this.selectedVariant.price;
            } else {
                return 0;
            }
        },
        extras() {
            let options = {};
            if(this.selected && this.selected.hasOwnProperty('extra_options') && this.items[this.selected.kit].length > 1) {
                this.items[this.selected.kit].forEach(item => {
                    if(!options.hasOwnProperty(item.extra_options.label)) {
                        options[item.extra_options.label] = [];
                    }
                    options[item.extra_options.label].push(item.extra_options.option);
                });
            }
            return options;
        },
        specialPrice() {
            return this.selectedVariant ? this.selectedVariant.price : 0;
        }
    },
    methods: {
        openModal(url) {
            this.$emit('modal', url);
        },
        onFinishChange(option) {
            let found = null;
            if(this.selected && this.selected.hasOwnProperty('kit') && this.items[this.selected.kit].length > 1) {
                found = this.items[this.selected.kit].find(item => item.extra_options.option === option);
            }
            if(found) {
                this.selected = found;
            }
        },
        openGallery(product) {
            const items = [];
            product.media.forEach(media => {
                if(media.media_type === 'image') {
                    items.push({
                        src:  media.src
                    })
                }
            })
            if(items.length > 0) {
                $.fancybox.open(items);
            }
        },
        onChange() {
            this.error = false;
            //this.$emit('select', this.selectedOptions);
        },
        onAdd() {
            if(this.selectedOptions.length < this.selected.options.length) {
                this.error = true;
                return false;
            }
            this.$emit('add', this.selectedOptions, this.selectedExtras, this.selected);
        },
        notAvailable(index, option) {
            if(this.selectedOptions.length === 0) {
                return true;
            }
            let found = [];
            if(index === 0) {
                found = this.selected.variants.filter(v => v.options[index] === option)
            } else if(index === 1) {
                if(this.selectedOptions[0]) {
                    found = this.selected.variants.filter(v => v.options[0] === this.selectedOptions[0] && v.options[index] === option)
                } else {
                    found = this.selected.variants.filter(v => v.options[index] === option)
                }
            } else if(index === 2) {
                if(this.selectedOptions[0] && this.selectedOptions[1]) {
                    found = this.selected.variants.filter(v => v.options[0] === this.selectedOptions[0] && v.options[1] === this.selectedOptions[1] && v.options[index] === option)
                } else if(this.selectedOptions[0]) {
                    found = this.selected.variants.filter(v => v.options[0] === this.selectedOptions[0] && v.options[index] === option)
                } else {
                    found = this.selected.variants.filter(v => v.options[index] === option)
                }
            }
            if(found.length === 0 && this.selectedOptions[index] === option) {
                this.selectedOptions.splice(index,1);
            }
            return found.length === 0;
        },
        isSalable(index, option) {
            if((index + 1) !== this.selected.options.length) {
                return true;
            }
            const found = this.selected.variants.find(v => v.options[index] === option);
            if(!found) {
                return true;
            }
            return found.available;
        },
        swatch(index, option) {
            const found = this.selected.swatches.find(s => s.label === option);
            return found;
        },
        goToNextStep() {
            if(this.selected === 3) {
                this.$emit('update', 3);
            } else if(this.selected && this.selected.hasOwnProperty('id')) {
                this.$emit('update', 2);
                setTimeout(() => {
                    this.updateImage();
                },500);
            }
        },
        //resetImages(reload) {
          
            // if(this.flkty.slides.length > this.totalImages) {
            //  if (this.flkty && this.flkty.slides && this.flkty.slides.length > this.totalImages) {
            //    this.flkty.getCellElements().forEach((cell, index) => {
            //        if((index + 1) > this.totalImages) {
            //            this.flkty.remove(cell);
            //        }
            //    });
           // }
           // if(reload) {
           //     this.flkty.select(0,false,true);
           // }
        resetImages(reload) {
          if (this.flkty && this.flkty.slides && this.flkty.slides.length > this.totalImages) {
            this.flkty && this.flkty.getCellElements().forEach((cell, index) => {
              if ((index + 1) > this.totalImages) {
                this.flkty && this.flkty.remove(cell);
                }
              });
            }
          if (reload) {
            this.flkty && this.flkty.select(0, false, true);
          }
        },
        updateImage(index,option) {
            this.error = false;
            if(!this.flkty) {
                return;
            }
            index = (typeof index === 'undefined') ? false : index;
            option = (typeof option === 'undefined') ? false : option;
            if(this.selectedVariant && this.selectedVariant.id) {
                let found = null;
                if(option) {
                    found = this.selected.variants.find(v => v.options[index] === option);
                } else {
                    found = this.selected.variants.find(v => v.id === this.selectedVariant.id);
                }

                if(found && found.image) {
                    const cellImg = new Image();
                    cellImg.onload = () => {
                        this.resetImages(false);
                        cellImg.setAttribute('width',cellImg.width);
                        const cell = document.createElement('div');
                        cell.className = 'product-gallery__image';
                        const cellLink =  document.createElement('a');
                        cellLink.setAttribute('href',found.image);
                        cellLink.className = 'product-gallery__link';
                        cellLink.setAttribute('data-fancybox',this.selectedVariant.product_id);
                        const cellLinkInner = document.createElement('span');
                        cellLinkInner.className = 'image__container';
                        cellLinkInner.appendChild(cellImg);
                        cellLink.appendChild(cellLinkInner);
                        cell.appendChild(cellLink);
                        this.flkty.append(cell);
                        console.log('this.flkty.slides after',this.flkty.slides.length);
                        this.flkty.select((this.flkty.slides.length - 1),false,true);
                        this.flkty.reloadCells();
                    }

                    cellImg.src = found.image;

                }
            }
        }
    },
    template: `<div class="bundle-products__kits yesyhereee" :class="{'loading': checkoutLoading}">
        <div class="legend">1. Choose Your Kit</div>
        <p v-if="step === 2 && selected"><strong>{{selected.title}}</strong> - <a href="#" @click.prevent="selected = null;$emit('update', 1)">Edit</a></p>
        <p v-if="step === 3"><strong>Build Your Kit</strong> - <a href="#" @click.prevent="selected = null;$emit('update', 1)">Edit</a></p>
        <div class="bundle-products__kits_wrapper" v-if="step === 1">
        
            <div class="bundle-products__kit" v-for="item in items" :key="item.id" @click.stop="selected = item[0]" :class="{'active': selected && selected.id === item[0].id}">
                <div class="item-image">
                    <a :href="item[0].img_url" @click.prevent.stop="openGallery(item[0])">
                       <img v-if="item[0].img_url" :src="item[0].img_url" alt="">
                    </a>
                </div>
                <div class="item-details">
                    <strong>{{item[0].hasOwnProperty('extra_options') && item[0].extra_options && item[0].extra_options.hasOwnProperty('name') ? item[0].extra_options.name : item[0].title}}</strong>
                    <p>{{item[0].short_description}}</p>
                    <div class="prices">
                        <strong :class="{'special-price': item[0].compare_at_price_max && item[0].compare_at_price_max > item[0].price}">{{formatCurrency(item[0].price)}}</strong>
                        <span v-if="item[0].compare_at_price_max && item[0].compare_at_price_max > item[0].price">{{formatCurrency(item[0].compare_at_price_max)}}</span>
                    </div>            
                </div>
            </div>
            
            <div class="bundle-products__kit" v-if="products && products.length > 0" @click.stop="selected = 3" :class="{'active': selected && selected === 3}">
                <div class="item-image">
                    <a :href="product.img_url" @click.prevent.stop="openGallery(product)">
                       <img v-if="product.img_url" :src="product.img_url" alt="">
                    </a>
                </div>
                <div class="item-details">
                    <strong>Build Your Kit</strong>
                    <p>{{product.short_description}}</p>
                    <div class="prices">
                        <strong v-if="from > 0">From {{formatCurrency(from)}}</strong>
                    </div>            
                </div>
                
            </div>
            <button type="button" class="button action_button button--add-to-cart" @click.prevent="goToNextStep()" :disabled="!selected">
              <span class="text">Continue</span>
            </button>
        </div>
        <div class="bundle-products__kit_options" v-if="step === 2 && selected && selected.hasOwnProperty('id')">
            <div class="heading">2. Choose Options</div>
            <div class="bundle-products__kit_options_wrapper">
                <div class="bundle-product__main-info">
                   <ul>
                        <li v-if="extras && Object.keys(extras).length > 0">
                          <template v-for="(extraValues, extraLabel, index) in extras">
                            <span>{{extraLabel}}</span><strong>{{selected.extra_options.option}}</strong>
                            <ul>
                                <li v-for="(option, jindex) in extraValues" :key="jindex">
                                    <input type="radio" class="sr-only" :value="option" :id="'extra-bundle-option-'+index+'-'+jindex" :checked="selected.extra_options.option === option" @change="onFinishChange(option)">
                                    <label :for="'extra-bundle-option-'+index+'-'+jindex">{{option}}</label>
                                </li>
                            </ul>
                          </template>                        
                        </li>
                        <li v-for="(mainOption, index) in mainOptions" :key="index">
                            <span>{{selected.options[index]}}</span><strong v-if="selectedOptions[index]">{{selectedOptions[index]}}</strong>
                            <fieldset class="swatch is-flex" v-if="selected.swatches.length > 0 && selected.options[index] && selected.options[index].toLowerCase() === 'color'">
                                <ul class="swatch__options">
                                    <li v-for="(option, jindex) in mainOption" :key="jindex" class="swatch__option">
                                        <input type="radio" class="sr-only" :value="option" v-model="selectedOptions[index]" :id="'main-bundle-option-'+index+'-'+jindex" @change="onChange()" :disabled="notAvailable(index,option) || !isSalable(index,option)" :data-variant-option-available="isSalable(index,option) ? 'true':'false'">
                                        <div tabindex="0" class="swatch-element color" @click="updateImage(index,option)">
                                            <div class="tooltip">{{option}}</div>
                                            <label :for="'main-bundle-option-'+index+'-'+jindex" class="swatch-label">
                                                <img v-if="swatch(index, option)" :src="swatch(index, option).src" :alt="option" />
                                            </label>
                                        </div>
                                        
                                    </li>
                                </ul>                            
                            </fieldset>
                            <ul v-else>
                                <li v-for="(option, jindex) in mainOption" :key="jindex">
                                    <input type="radio" class="sr-only" :value="option" v-model="selectedOptions[index]" :id="'main-bundle-option-'+index+'-'+jindex" @change="onChange()" :disabled="notAvailable(index,option) || !isSalable(index,option)">
                                    <label :for="'main-bundle-option-'+index+'-'+jindex">{{option}}</label>
                                </li>
                            </ul>
                            <p v-if="selected && selected.hasOwnProperty('options_links') && selected.options_links && selected.options_links.hasOwnProperty(selected.options[index])"><a :href="'/pages/'+selected.options_links[selected.options[index]]" @click.prevent="openModal('/pages/'+selected.options_links[selected.options[index]])">What's the difference?</a></p>                            
                        </li>
                    </ul>
                    <p class="error" v-if="error">⚠ Please select options</p>
                </div>
            </div>
            <div class="bundle-products__form" :class="{'loading': checkoutLoading}">
              <div class="bundle-products__price">
                <div>
                  <span v-if="specialPrice > 0" v-html="formatCurrency(specialPrice)" class="special-price"></span>
                  <span class="old-price" v-if="price > specialPrice">{{formatCurrency(price)}}</span>
                  <span class="save-price" v-if="price > specialPrice">Save {{formatCurrency(price - specialPrice)}}</span>
                </div>
              </div>
              <button type="button" class="button action_button button--add-to-cart" @click.prevent="onAdd()">
                <span class="text">Add to Cart</span>
              </button>
              <div class="product-form-promo">Free Continental U.S. Shipping $99+</div>
              <div class="loading-ripple" v-if="checkoutLoading"><div></div><div></div></div>
            </div>
        </div>
    </div>`
}
const tesbrosBundlesApp = Vue.createApp({
    components: {
        'kits': tesbrosBundleKits,
        'product': tesbrosBundleProduct,
        'tier': tesbrosBundleTier,
        'modal': tesbrosBundleModal
    },
    data() {
        return {
            isMounted: false,
            mainProduct: {},
            mainOptions: [],
            products: [],
            kits: [],
            kitProducts: [],
            finish: 'Gloss',
            price: 0,
            cartAddUrl: '/cart/add.js',
            checkoutLoading: false,
            isError: false,
            fetchHeaders: new Headers({'pragma':'no-cache','cache-control':'no-store','Content-Type':'application/json','Accept': 'application/json'}),
            freeItem: null,
            flkty: null,
            mainImage: null,
            totalImages: 0,
            from: 0,
            step: 1,
            showModal: false,
            modalHeader: null,
            modalBody: null,
            tiers: []
        }
    },
    created() {
        try {
            if(document.getElementById('bundle-free-item')) {
                this.freeItem = JSON.parse(document.getElementById('bundle-free-item').innerText);
            }
            this.mainProduct = JSON.parse(document.getElementById('bundle-main').innerText);
            this.mainProduct.selected_variant_id = this.mainProduct.default_variant_id;
            this.tiers = JSON.parse(document.getElementById('bundle-tiers').innerText);
            this.products = JSON.parse(document.getElementById('bundle-parts').innerText);
            this.kits = JSON.parse(document.getElementById('bundle-kits').innerText);
          console.log(this.kits);
          console.log("here are kits");
            this.kitProducts = this.kits.flat();
            this.from = (this.products && this.products.length > 0) ? Math.min(...this.products.map(p => p.price)) : 0;
            const variants = this.products.map(product => product.variants).flat();
            store.dispatch('bundles/set', {
                items: variants
            });
            if(this.mainProduct.options && this.mainProduct.options.length > 0) {
                this.mainProduct.options.forEach((option, index) => {
                    this.mainOptions.push([...new Set(this.mainProduct.variants.map(variant => variant.options[index]))]);
                });
            }
            const gallery = document.querySelector('.product-gallery__main');
            let intervalFlickityCnt = 0;
            let intervalFlickity = setInterval(()=> {
                if(intervalFlickityCnt === 10) {
                    clearInterval(intervalFlickity);
                }
                if(typeof Flickity !== "undefined" && Flickity.data('.product-gallery__main')) {
                    clearInterval(intervalFlickity);
                    this.flkty = Flickity.data('.product-gallery__main');
                    this.totalImages = this.flkty.slides.length;
                    this.mainImage = document.querySelector('.product-gallery__image[data-featured-image] .image__container');
                }
                intervalFlickityCnt++;
            },1000);
        } catch (e) {
            console.error(e);
        }
    },
    mounted () {
        setTimeout(() => {
            this.isMounted = true;
        },250);
    },
    provide() {
        return {
            products: Vue.computed(() => this.products),
            tiers: Vue.computed(() => this.tiers),
            freeItem: Vue.computed(() => this.freeItem),
            checkoutLoading: Vue.computed(() => this.checkoutLoading),
            mainOptions: Vue.computed(() => this.mainOptions),
            step: Vue.computed(() => this.step),
            from: Vue.computed(() => this.from),
            flkty: Vue.computed(() => this.flkty),
            totalImages: Vue.computed(() => this.totalImages),
            mainImage: Vue.computed(() => this.mainImage),
            showModal: Vue.computed(() => this.showModal),
            modalHeader: Vue.computed(() => this.modalHeader),
            modalBody: Vue.computed(() => this.modalBody),
            isMounted: Vue.computed(() => this.isMounted),
        }
    },
    computed: {
        variants() {
            return store.getters['bundles/items'];
        },
        filtered() {
            return this.variants.filter(variant => variant.options[0] === this.finish || variant.default_variant === true);
        },
        inCart() {
            return this.variants.filter(variant => variant.in_cart === true && variant.id !== this.freeItem.variants[0].id);
        },
        inCartWithImages() {
            return this.variants.filter(variant => variant.in_cart === true && variant.bundle_image !== null);
        },
        freeItemInCart() {
            return this.variants.find(variant => variant.in_cart === true && variant.id === this.freeItem.variants[0].id);
        },
        prices() {
            return this.filtered.map(variant => variant.price);
        },
        total() {
            if(this.inCart && this.inCart.length > 0) {
                if(!this.freeItemInCart) {
                    return this.inCart.map(item => item.price).reduce((prev, next) => prev + next);
                } else {
                    const subtotal = this.inCart.map(item => item.price).reduce((prev, next) => prev + next);
                    return subtotal + this.freeItem.variants[0].price;
                }
            } else {
                return Math.min(...this.prices);
            }
        },
        special() {
            if(this.inCart.length > 1) {
                let subtotal = this.inCart.map(item => item.price).reduce((prev, next) => prev + next);
                subtotal = subtotal - (subtotal * this.tier.percent / 100);
                return subtotal;
            } else {
                return this.tier.percent > 0 ? (this.total - (this.total * this.tier.percent / 100)) : 0;
            }
        },
        save() {
            return 'Save ' + this.formatCurrency(this.total - this.special);
        },
        tier() {
            let tier = {
                'percent': 0
            };
            if(this.inCart && this.inCart.length > 0) {
                let itemsInCart = this.inCart.length;
                if(itemsInCart === 1 && this.freeItemInCart) {
                    itemsInCart = 2;
                }
                const tiers = this.tiers.filter(t => itemsInCart >= t.min);
                tier = tiers.length > 0 ? tiers.reduce((prev, current) => (prev.min > current.min) ? prev : current) : tier;
            }
            return tier;
        }
    },
    methods: {
        reset() {
            this.variants.forEach(variant => {
                variant.in_cart = false;
            });
        },
        updateStep(s) {
            this.step = s;
        },
        toggle(item) {
            this.isError = false;
            item.in_cart = !item.in_cart;
            this.updateFreeItem();
            this.updateMedia(item);
        },
        openModal(url) {
            this.checkoutLoading = true;
            fetch(url)
                .then((response) => response.text())
                .then((response) => {
                    const page = new DOMParser().parseFromString(response, 'text/html');
                    const contents = page.querySelector('.page__content').innerHTML;
                    this.modalHeader = 'Learn More';
                    this.modalBody = contents;
                    this.showModal = true;
                }).catch((e) => {
                    console.error(e)
                }).finally(() => {
                    this.checkoutLoading = false;
                });
        },
        closeModal() {
            this.showModal = false;
        },
        selectMainProduct(selected) {
            const variant = this.mainProduct.variants.find(v => v.options.length === selected.length && v.options.every((value,index) => value === selected[index]));
            if(variant) {
                this.mainProduct.selected_variant_id = variant.id;
            }
        },
        addMainProduct(selected) {
            const variant = this.mainProduct.variants.find(v => v.options.length === selected.length && v.options.every((value,index) => value === selected[index]));
            if(variant) {
                const data = {
                    items: [ {id: variant.id, quantity: 1} ]
                };
                this.postToCart(data);
            }
        },
        addKit(selectedOptions, selectedExtras, selected) {
            const kit = this.kitProducts.find(k => k.id === selected.id);
            if(kit) {
                const variant = kit.variants.find(v => v.options.length === selectedOptions.length && v.options.every((value,index) => value === selectedOptions[index]));
                if(variant) {
                    let data = {
                        items: [ {id: variant.id, quantity: 1} ]
                    };
                    if(selectedExtras && Object.keys(selectedExtras).length > 0) {
                        let properties = {};
                        for(const label in selectedExtras) {
                            properties[label] = selectedExtras[label];
                        }
                        data.items[0]['properties'] = properties;
                    }
                    this.postToCart(data);
                }
            }
        },
        updateMedia(item) {
            if(this.flkty && this.mainImage) {
                let hasImages = [];
                this.mainImage.querySelectorAll(':scope > img').forEach((el) => {
                    let found = false;
                    this.inCartWithImages.forEach((cartItem) => {
                        if(cartItem.bundle_image === el.getAttribute('src')) {
                            found = true;
                        }
                    })
                    if(!found) {
                        el.remove();
                    } else {
                        hasImages.push(el.getAttribute('src'));
                        el.classList.remove('animated');
                    }
                });
                const hasMoreImages = this.inCartWithImages.filter(cartItem => hasImages.indexOf(cartItem.bundle_image) === -1);
                if(hasMoreImages.length > 0) {
                    this.inCartWithImages.forEach((cartItem) => {
                        if(hasImages.indexOf(cartItem.bundle_image) === -1) {
                            const img = document.createElement('img');
                            img.setAttribute('class','bundle-part-image');
                            img.onload = () => {
                                this.mainImage.appendChild(img);
                                this.mainImage.querySelectorAll(':scope > img.bundle-part-image').forEach((el) => {
                                    el.classList.add('animated');
                                });
                            }
                            img.src = cartItem.bundle_image;
                        }
                    });
                } else {
                    this.mainImage.querySelectorAll(':scope > img.bundle-part-image').forEach((el) => {
                        el.classList.add('animated');
                    });
                }
                if(item.in_cart) {
                    this.flkty.select(0);
                }
            }
        },
        updateFreeItem() {
            if(this.inCart.length > 1) {
                let freeItem = this.variants.find(variant => variant.id === this.freeItem.variants[0].id);
                freeItem.in_cart = true;
            }
        },
        addToCart() {
            if(this.inCart && this.inCart.length > 0) {
                const data = {
                    items: []
                };
                this.variants.forEach(variant => {
                    if(variant.in_cart) {
                        const item = {id: variant.id, quantity: 1};
                        data.items.push(item);
                    }
                });
                if(data.items.length > 0) {
                    this.postToCart(data);
                }
            } else {
                this.isError = true;
            }
        },
        postToCart(data) {
            const body = JSON.stringify(data);
            this.checkoutLoading = true;
            fetch(this.cartAddUrl,{method: 'POST', headers: this.fetchHeaders , body})
                .then((response) => {
                    this.reset();
                    const event = new CustomEvent("cart-item-added",{bubbles: true});
                })
                .catch((e) => {
                    console.error(e);
                }).finally(() => {
                this.checkoutLoading = false;
            });
        }
    }
}, { ...bundlesRootEl.dataset })
tesbrosBundlesApp.use(tesbrosPlugin).use(store);
tesbrosBundlesApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('swatches') && !tag.includes('vueper')
tesbrosBundlesApp.config.unwrapInjectedRef = true
tesbrosBundlesApp.mount('#bundleProductApp');
